<template>
  <div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h4>
                     تقييمات الطلاب
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                        <label for="rates-teacher">المعلم</label>
                        <select id="rates-teacher" class="form-control" v-model="teacher">
                            <option value="all">الكل</option>
                            <option v-for="t in teachers" :key="t" :value="t">
                                {{ t }}
                            </option>
                        </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                        <label for="rates-classroom">الفصل</label>
                        <select id="rates-classroom" class="form-control" v-model="classroom">
                            <option value="all">الكل</option>
                            <option v-for="t in classrooms" :key="t" :value="t">
                                {{ t }}
                            </option>
                        </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                        <label for="rates-content">التقييم</label>
                        <select id="rates-content" class="form-control" v-model="content">
                            <option value="all">كل التقييمات</option>
                            <option v-for="t in contents" :key="t.text" :value="t.text">
                                {{ t.text }} ({{ t.count }})
                            </option>
                        </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                        <label for="rates-kind">النوع</label>
                        <select id="rates-kind" class="form-control" v-model="kind">
                            <option value="all">الكل</option>
                            <option value="positive">إيجابي</option>
                            <option value="negative">سلبي</option>
                        </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                        <label for="rates-name">بحث عن طالب</label>
                        <input id="rates-name" class="form-control" placeholder="الاسم هنا..." v-model="name">
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                        <label for="rates-sort">ترتيب الطلاب</label><br>
                        <sort-select id="rates-sort" v-model="sort" />
                        </div>
                    </div>
                </div>
                <div class="rates-summary">
                    المعروض: <strong>{{ shownRates.length }}</strong> تقييم
                    <span v-if="pickedRates.length"> · المحدد: <strong class="text-success">{{ pickedRates.length }}</strong>
                        <a href="javascript:;" style="margin-inline-start: 8px" @click="picked = []">إلغاء التحديد</a>
                    </span>
                    <span v-if="filtered" style="margin-inline-start: 6px">
                        · <a href="javascript:;" @click="clearFilters()"><i class="fa fa-times"></i> مسح الفلاتر</a>
                    </span>
                </div>
                <button class="btn btn-sm btn-primary" style="border-radius: 0px" @click="print()">
                    <i class="fa fa-print"></i> طباعة الجدول
                </button>
                <input type="date" v-model="date" style="border-radius: 0px; height: 28px; position: relative; top: 1px">
                <button class="btn btn-sm btn-success" style="border-radius: 0px" v-b-modal.send :disabled="!sendRates.length" @click="f = sendRates.slice()">
                    <i class="fa fa-paper-plane"></i>
                    <span v-if="pickedRates.length">ارسال التقييمات المحددة ({{ pickedRates.length }}) لأولياء الامور</span>
                    <span v-else>ارسال التقييمات المعروضة ({{ shownRates.length }}) لأولياء الامور</span>
                </button>
                <b-modal id="send" title="ارسال لأولياء الامور" hide-footer>
                    <div class="alert alert-warning g text-center">
                        <span class="text-dark">سيتم إرسال {{ f.length }} رسالة</span>
                        <br>
                        <small class="text-secondary">يُرسل {{ pickedRates.length ? 'المحدد من الجدول فقط' : 'كل التقييمات المعروضة حسب الفلاتر (المعلم، الفصل، التقييم، النوع، التاريخ)' }}.</small>
                    </div>
                    <div class="form-group">
                      <h5 for="">الرسالة</h5>
                      <textarea class="form-control" placeholder="الرسالة هنا" v-model="message" rows="3"></textarea>
                    </div><div class="row">
            <div class="col-12 col-lg-6 g">
                <b-dropdown style="width: 100%"
                    id="dropdown-1" dropup size="lg"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                >
                    <template #button-content>
                        <i class="fa fa-whatsapp"></i>
                        واتساب
                    </template>
                    <b-dropdown-item @click="send('whatsapp')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-1.png')" style="width: 28px;">
                        واتساب تلقائي (الواتس الذكي)</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="send('wa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-2.png')" style="width: 28px;">
                            اداة المتصفح المجانية</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="send('xwa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-3.png')" style="width: 28px;">
                        الاداة المتطورة (الواتس المباشر) <i class="btn btn-danger" style="padding: 2px">جديد</i></span>
                    </b-dropdown-item>
                    <div class="text-center g">
                        <a href="/whats-methods" target="_blank">ما الفرق بينهم؟</a>
                    </div>
                </b-dropdown>
                <meta-send-button size="lg" class="mt-50" @send="send('meta')" />
            </div>
            <div class="col-12 col-lg-6 g">
                <button class="btn btn-primary btn-block btn-lg"  @click="send('sms')">
                    <i class="fa fa-mobile"></i>
                    SMS
                </button>
                <button class="btn btn-outline-primary mt-50 btn-block btn-lg"  @click="send('push')">
                    <i class="fa fa-bell"></i>
                    إشعار الجوال
                </button>
            </div>
        </div>
                </b-modal>
                <div class="col-12 table-responsive" id="printme" style="padding: 0px">
                    <table class="table table-hover table-sm table-bordered table-striped">
                        <thead>
                            <tr>
                                <th class="hidemonprint rates-check">
                                    <input type="checkbox" aria-label="تحديد كل المعروض" :checked="allPicked" :indeterminate.prop="pickedRates.length > 0 && !allPicked" @change="toggleAll($event.target.checked)">
                                </th>
                                <th>
                                    الطالب
                                </th>
                                <th>
                                    المعلم
                                </th>
                                <th>
                                    التقييم
                                </th>
                                <th>
                                    التاريخ	
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="rate in shownRates" :key="rate._id" :class="{ 'rates-picked': picked.includes(rate._id) }" @click="togglePick(rate._id, $event)">
                                <td class="hidemonprint rates-check">
                                    <input type="checkbox" :aria-label="'تحديد ' + rate.student_name" :value="rate._id" v-model="picked">
                                </td>
                                <td>
                                    {{ rate.student_name }}
                                </td>
                                <td>
                                    {{ rate.teacher_name }}
                                </td>
                                <td>
                                    <span :class="rate.point > 0 ? 'text-success' : (rate.point < 0 ? 'text-danger' : '')">{{ rate.content }}</span>
                                </td>
                                <td>
                                    {{ rate.date }}
                                </td>
                            </tr>
                            <tr v-if="!shownRates.length">
                                <td colspan="5" class="text-center text-muted">لا توجد تقييمات مطابقة للفلاتر</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
import { sort_rows } from '@/libs/list-sort'
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        vSelect,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            rates: [],
            f: [],
            teachers: [],
            teacher: "all",
            classrooms: [],
            classroom: "all",
            students: [],
            message: `تم إضافة تقييم لإبنكم {name}
التقييم: {rate}
بتاريخ: {date}`,
            original: [],
            date: "",
            name: "",
            content: "all",
            kind: "all",
            picked: [],
            sort: "",
            user: JSON.parse(localStorage.getItem('user')),
        }
    },
    computed: {
        // ratings in the chosen order of their students (class from the students list)
        sortedRates(){
            var by = {};
            this.students.forEach(function(s){ by[s.number] = s; });
            return sort_rows(this.rates.map(function(x){
                var s = by[x.number] || {};
                return { name: x.student_name, classname: s.classname, classroom: s.classroom, row: x };
            }), this.sort).map(function(x){ return x.row; });
        },
        // what the table shows: every filter together (teacher, class, rating, type, name, date)
        shownRates(){
            var g = this, name = (g.name || '').trim();
            return g.sortedRates.filter(function(x){
                if(g.teacher != 'all' && x.teacher_name != g.teacher) return false;
                if(g.classroom != 'all' && x.classroom != g.classroom) return false;
                if(g.content != 'all' && (x.content || '').trim() != g.content) return false;
                if(g.kind == 'positive' && !(Number(x.point) > 0)) return false;
                if(g.kind == 'negative' && !(Number(x.point) < 0)) return false;
                if(name && !(x.student_name || '').includes(name)) return false;
                if(g.date && !(x.date || '').includes(g.date)) return false;
                return true;
            });
        },
        // the rating texts for the «التقييم» filter, most used first
        contents(){
            var count = {};
            this.rates.forEach(function(x){
                var t = (x.content || '').trim();
                if(t) count[t] = (count[t] || 0) + 1;
            });
            return Object.keys(count).map(function(t){ return { text: t, count: count[t] }; })
                .sort(function(a, b){ return b.count - a.count || a.text.localeCompare(b.text, 'ar'); });
        },
        // the ticked rows that are still shown (a filter can hide a ticked row: it is not sent then)
        pickedRates(){
            var picked = this.picked;
            return this.shownRates.filter(function(x){ return picked.includes(x._id); });
        },
        allPicked(){
            return this.shownRates.length > 0 && this.pickedRates.length == this.shownRates.length;
        },
        // ticked rows when any, else everything shown
        sendRates(){
            return this.pickedRates.length ? this.pickedRates : this.shownRates;
        },
        filtered(){
            return this.teacher != 'all' || this.classroom != 'all' || this.content != 'all' || this.kind != 'all' || !!this.name || !!this.date;
        },
    },
    created(){
        if(!checkPer("students|rates")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.getrates();
        $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            q: this.q,
            page: 1,
            perpage: 10000
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.students = r.response
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    methods: {
        send(method){
            var g = this;
            var messages = [];
            g.f.forEach(function(a){
                var v = [];
                g.students.forEach(function(ax){
                    if(ax.number == a.number){
                        v = ax.phones
                    }
                })
                messages.push({
                    phones: v,
                    message: convertToHijri(g.message.replace("{name}", a.student_name).replace("{rate}", a.content).replace("{date}", a.date.split(' ')[0]))
                })
            })
            if(method == 'wa'){
                $("#sendmodalwaarray").val(JSON.stringify(messages))
                $("#sendmodalwatype").val("students")
                $("#sendWAModal").click()
                    $(".x345").removeClass('btn-success')
                    $(".x345").addClass('btn-outline-danger')
                    $(".x345").html("<i class='fa fa-refresh'></i> حدث الصفحة للارسال من الاداة مرة أخرى")
            }else{
                $.post(api + '/user/messages/send-arr', {
                    jwt: g.user.jwt,
                    arr: JSON.stringify(messages),
                    method: method,
                    type: "students"
                }).then(function(r){
                    g.loaded = true;
                    if(r.status != 100){
                        alert(r.response, 200)
                    }else{
                        alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                    }
                }).fail(function(){
                    alert("حدث خطأ", 200)
                })
            }
        },
        print(){
            var g = this;
            var divToPrint=document.getElementById("printme");
            var newWin= window.open("");
            newWin.document.write(`
            <style>
            html, body{
                direction: rtl
            }
            .hidemonprint{
                display:none;   
            }
            table, td, th {
            border: 1px solid;
            }

            table {
            width: 100%;
            border-collapse: collapse;
            }
            </style>
            ` + divToPrint.innerHTML);
            newWin.document.close()
            newWin.print();
        },
        // kept for old callers: the table now follows the filters by itself (shownRates)
        filter(){},
        clearFilters(){
            this.teacher = 'all'; this.classroom = 'all'; this.content = 'all'; this.kind = 'all'; this.name = ''; this.date = '';
        },
        toggleAll(on){
            var ids = this.shownRates.map(function(x){ return x._id; });
            this.picked = on
                ? Array.from(new Set(this.picked.concat(ids)))
                : this.picked.filter(function(id){ return !ids.includes(id); });
        },
        // a click anywhere on the row ticks it (the checkbox itself already does)
        togglePick(id, e){
            if(e && e.target && e.target.tagName == 'INPUT') return;
            var i = this.picked.indexOf(id);
            if(i < 0) this.picked.push(id); else this.picked.splice(i, 1);
        },
        getrates(){
            var g = this;
            $.post(api + '/user/students/rates', {
                jwt: this.user.jwt,
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.rates = r.response;
                    g.original = r.response;
                    g.rates.forEach(function(a){
                        if(!g.classrooms.includes(a.classroom)){
                            g.classrooms.push(a.classroom)
                        }
                        if(!g.teachers.includes(a.teacher_name)){
                            g.teachers.push(a.teacher_name)
                        }
                    })
                }
            }).fail(function(){
                g.loading = false;
            })
        },
    }
}
</script>

<style>
@import url(https://cdnjs.cloudflare.com/ajax/libs/vue-select/3.10.0/vue-select.css);
.rates-summary{ margin: 0 0 10px; color: #5e5873; font-size: 13px; }
.rates-check{ width: 34px; text-align: center; }
.rates-check input{ width: 16px; height: 16px; cursor: pointer; vertical-align: middle; }
#printme tbody tr{ cursor: pointer; }
#printme tbody tr.rates-picked td{ background: rgba(40, 199, 111, .12) !important; }
#vs3__listbox{
    max-height: 150px !important;
    overflow: hidden !important;
}
</style>